import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Sticky from 'react-stickynode';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import styled from 'styled-components';
import { mediaMUI } from 'theme/styled-theme';
import ItineraryPlaceCardList from 'components/NewItinerary/PlaceCardList/Loadable';
import TabPanel from 'components/ItineraryRouteTabs/TabPanel/Loadable';
import Tabs from 'components/ItineraryRouteTabs/Tabs/Loadable';
import Tab from 'components/ItineraryRouteTabs/Tab/Loadable';
import { Element as ScrollElement, scroller } from 'react-scroll';
import { sendEvent } from 'utils/gtag';

const Root = styled.div`
  position: relative;
  width: 100%;

  .toolbarStickyActive .sticky-inner-wrapper {
    border-bottom: 1px solid rgba(180,180,180,0.4);
  }
`;

const GutterBottom = styled.div`
  position: relative;
  width: 100%;
  margin-bottom: 1.5rem;
`;

const MapButton = styled.div`
  display: inline-flex;
  margin-left: auto;
`;

const StickyWrap = styled.div`
  && {
    display: flex;
    background: white;
  }
`;

const ItineraryRouteTabs = props => {
  // useWhyDidYouUpdate('ItineraryRouteTabs', props);
  const {
    data, slug, setStep, clearEnquiry, setCurrentDay, renderGmapButton
  } = props;
  const [current, setCurrent] = useState(0);
  const [enableSticky, setEnableSticky] = useState(false);
  const matchPhone = useMediaQuery(mediaMUI.forPhoneOnly);
  const handleChange = (event, newValue) => {
    setCurrent(newValue);
    setCurrentDay(newValue);
    sendEvent({ action: 'Click Itinerary Day Tab Item', category: 'engagement' });
    scroller.scrollTo('start-of-itineary', {
      offset: -96,
      duration: 300,
    });
  };

  // Wait until after client-side hydration to show
  useEffect(() => {
    setEnableSticky(true);
  }, []);

  const getTabPanel = _data => _data.map((day, index) => (
    <TabPanel
      value={current}
      index={index}
      key={`TabPanel-${index}`}
    >
      <ItineraryPlaceCardList
        places={day}
        slug={slug}
        day={index}
        setStep={setStep}
        clearEnquiry={clearEnquiry}
      />
    </TabPanel>
  ));

  const renderTab = () => data.map(
    (_, index) => (
      <Tab
        matchPhone={matchPhone}
        index={index}
        keyValue={`itinerary-tab-${index}`}
        handleChange={handleChange}
      />
    )
  );

  return (
    <Root key="ItineraryRouteTabs">
      <Sticky
        key="ItineraryRouteTabsSticky"
        enabled={enableSticky}
        top={47}
        innerZ={1200}
        bottomBoundary="#bottom-elem-for-sticky"
        activeClass="toolbarStickyActive"
      >
        <StickyWrap>
          <Tabs
            matchPhone={matchPhone}
            onChange={handleChange}
            current={current}
            data={data}
            renderTab={renderTab}
          />
          <MapButton>
            { renderGmapButton }
          </MapButton>
        </StickyWrap>
      </Sticky>

      <ScrollElement name="start-of-itineary" />
      <GutterBottom />

      { getTabPanel(data) }
    </Root>
  );
};

ItineraryRouteTabs.propTypes = {
  data: PropTypes.arrayOf(PropTypes.any),
  slug: PropTypes.string,
  setStep: PropTypes.func,
  clearEnquiry: PropTypes.func,
  setCurrentDay: PropTypes.func,
  renderGmapButton: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
};

ItineraryRouteTabs.defaultProps = {
  data: [],
  slug: '',
  setStep: () => {},
  clearEnquiry: () => {},
  setCurrentDay: () => {},
  renderGmapButton: () => {},
};

export default ItineraryRouteTabs;
